import React, { useState, setState } from 'react';
import "./login.css";
import Interra from "../images/logo.png";
import Illustration from "../images/illustrationLog.png";
import { useNavigate } from 'react-router-dom';
import { signInWithGoogle, db } from '../firebase';
import { collection, addDoc, getDocs } from "firebase/firestore";
import { useEffect } from 'react';

import EmailIcon from '@mui/icons-material/Email';
// import { signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
// import { auth } from '../firebase'
import { recaptaSetup } from '../firebase'
import { toast } from 'react-toastify';

function Login() {

  const navi = useNavigate();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [user, setUser] = useState([]);
  const [data, setData] = useState([]);

  // Collected the user Data from the database
  useEffect(() => {
    const getData = async () => {
      const data = await getDocs(collection(db, "USER_REG"));
      setUser(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));

    }
    getData();
  }, [])

  // const emailPassWordLogin = async () => {
  //   try {
  //     const user = await signInWithEmailAndPassword(auth, email, passwor);
  //     console.log(user)
  //   } catch (error) {
  //     console.log(error.message);
  //   }
  // }

  function ClickLogo() {
    let path = `/`;
    navi(path);
  }
  const handleClick = () => {

    signInWithGoogle();
    setData({
      Name: localStorage.getItem('Name'), PhotoURL: localStorage.getItem("PhotoURL"),
      Email: localStorage.getItem("Email")
    });

    navi("/influencer-search");
  }

  const handleContinue = async (e) => {
    e.preventDefault();


    //regex for phone number
    const regex = /^[6-9]\d{9}$/;

    if (phone === "" || phone === undefined || phone === null || regex.test(phone) === false) {
      toast.warn('Please Enter Valid Phone Number', {
        position: "top-right",
        autoClose: 2200,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navi("/login");
    }

    else if (user) {
      let flag = false;
      user.map((item) => {
        if (item.email == email) {
          localStorage.setItem("Phone", "+91" + phone);
          localStorage.setItem("Email", email);
          flag = true;
          toast.success('🦄Logged In Successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navi('/otp');
        }
      }
      )

      if (!flag) {
        toast.warn('Unsuccessfull Please Register First', {
          position: "top-right",
          autoClose: 2200,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navi("/signup");
      }
    }
    else {
      localStorage.setItem("Phone", "+91" + phone);
      localStorage.setItem("Email", email);
      navi("/otp");
    }
    // let digitAlpha = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    // let OTP = '';
    // for (let i = 0; i < 4; i++) {
    //   OTP += digitAlpha[Math.floor(Math.random() * 10)];
    // }

    // localStorage.setItem("Phone", phone);
    // let OTP_Object = { phone: phone, OTP: OTP }
    // try {
    //   let res = await addDoc(OTPCollectionReference, OTP_Object);
    //   console.log(res);

    //   navi("/otp");
    // }
    // catch (err) {
    //   console.log(err);
    // }


  }



  // const [confirm, setConfirm] = useState(false);

  // const handleInputChange = (e) => {
  //   const { id, value } = e.target;
  //   if (id === "email") {
  //     console.log("hiii");
  //     setEmail(value);
  //   }
  //   if (id === "phone") {
  //     setPhone(value);
  //   }
  // }



  // if(confirm)
  // {
  //   return(
  //     Navigate("/Otp")
  //   );
  // }
  let myObj = { email: email, phone: phone };
  /*
  console.log("myData -->", data);
  console.log("myObj --->", myObj);
   
  */

  return (
    <div className="outer">
      <img src={Interra} className="logo" alt='interra-img' onClick={ClickLogo}></img>
      <div className="box">
        <div class="row">
          <div class="column">
            <div className="login1">
              Please enter your phone number to recieve a
              verification code to login and use Interra
            </div>

            <div className="phone">
              <input type="text" placeholder="Phone Number" className="fields" value={phone} onChange={(e) => setPhone(e.target.value)} />
            </div>

            <div className="input-icons1">
              <i className="fa fa-envelope icon">
              </i>
              <input className="fields"
                type="text"
                placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} ></input>
            </div>

            <div className="remember">
              <input type="radio" className="check"></input>  Remember me
            </div>
            <div className="loginButton">
              <button className="google" onClick={handleClick}>Sign in with Google</button>
            </div>
            <div className="loginButton" onClick={handleContinue}>
              <button type="submit" className="cont1" >
                Continue
                {/* Continue */}
              </button>

            </div>
          </div>

          <div class="column c">
            <img src={Illustration} className="ill1" alt='img-2'></img>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Login